import React from 'react';

/**
 * Simple skeleton placeholder for a repository card
 */
const RepoSkeleton = () => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 animate-pulse dark:bg-gray-800 dark:border-gray-700">
      <div className="p-5">
        <div className="flex items-start justify-between gap-4 mb-3">
          <div className="flex-1 min-w-0">
            <div className="h-6 bg-gray-200 rounded w-2/5 mb-3 dark:bg-gray-700"></div>
          </div>
          <div className="w-16 h-6 bg-gray-200 rounded dark:bg-gray-700"></div>
        </div>

        <div className="space-y-2 mb-4">
          <div className="h-3 bg-gray-200 rounded w-full dark:bg-gray-700"></div>
          <div className="h-3 bg-gray-200 rounded w-11/12 dark:bg-gray-700"></div>
          <div className="h-3 bg-gray-200 rounded w-3/4 dark:bg-gray-700"></div>
        </div>

        <div className="flex items-center gap-3 pt-3 border-t border-gray-100">
          <div className="w-10 h-10 bg-gray-200 rounded-full dark:bg-gray-700"></div>
          <div className="h-4 bg-gray-200 rounded w-24 dark:bg-gray-700"></div>
        </div>
      </div>
    </div>
  );
};

export default RepoSkeleton;
